import React, { useState, useEffect } from 'react';
import CreateAction from '../../../components/operational/createAction';

const ChartOne = dateRange => {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <div>
      <div
        style={{
          fontSize: '17px',
          color: '#494949',
          paddingLeft: '15px',
          paddingRight: '15px',
          paddingTop: '20px',
          paddingBottom: '20px',
          borderBottom: '1px solid #E5E7EB',
        }}
      >
        Dönüşüm Hunisi
      </div>
      {errorMessage ? (
        <div className="p-2">
          <div className="text-red-500 text-center py-4">{errorMessage}</div>
        </div>
      ) : (
        <div>
          <div className="text-red-500 text-center py-4"> Yakında Eklenecek</div>
        </div>
      )}
    </div>
  );
};

export default ChartOne;
